interface IProps {
  size: number;
}

export const CompanyIcon = ({ size }: IProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M17 15H19V17H17V15Z" fill="currentColor" />
    <path d="M19 11H17V13H19V11Z" fill="currentColor" />

    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13 7H23V21H1V3H13V7ZM8 5H11V7H8V5ZM11 19V17H8V19H11ZM11 15V13H8V15H11ZM11 11V9H8V11H11ZM21 19V9H13V11H15V13H13V15H15V17H13V19H21ZM3 19V17H6V19H3ZM3 15H6V13H3V15ZM6 11V9H3V11H6ZM3 7H6V5H3V7Z"
      fill="currentColor"
    />
  </svg>
);
